namespace Gordic.Vyp.Icons
{
    export enum ActionEnum
    {
        frankovaniOnline = "fa-pencil-square-o",
        frankovaniOffline = "fa-link",
    }
}

namespace Gordic.Vyp.Globals.Enums
{
    export enum ActionsName {
        Vypravit = "actVypravit",
        OveritAdresaty = "actOveritAdresaty",
        FrankovaniOnline = "actFrankovaniOnline",
        FrankovaniOffline = "actFrankovaniOffline",
        PrevzitSFrankovanim = "actPrevzitSFrankovanim",
        ImportDatEpaPosty = "actImportDatEpaPosty",
        TiskPodacihoArchu = "actTiskPodacihoArchu",
        TiskEvidListPostovneho = "actTiskEvidListPostovneho",
        TiskKnihyVypravenePosty = "actTiskKnihyVypravenePosty",
        TiskVykazu = "actTiskVykazu",
        TiskNakladu = "actTiskNakladu",
    }

    //---------------------------------------------------------------------
    export enum TypTiskuPodacihoArchu {
        netisknou = 0,
        tisknout = 10,
        tisknoutDoporucene = 30,
        tisknoutDoZahranici = 50,
        tisknoutDoZahraniciDoporucene = 60,
    }
}
